import { Component, OnInit } from '@angular/core';

import { NonIntegratedAppFacade } from '@app/core/facades/non-integrated-app.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

@Component({
  selector: 'app-filter-non-integrated-course',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class NonIntegratedCourseFilterComponent extends FilterComponent implements OnInit {
  public readonly width = 'auto';
  public readonly label = 'Course';

  constructor(private readonly _data: NonIntegratedAppFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateCourseId(value);
    this.valueChange.emit(new FilterChange(FilterType.NonIntegrationCourse, value));
  }

  ngOnInit() {
    this.init(this._data.courseId$, this._data.allApps$, this._data.coursesFiltered$);
  }
}
